import { Splide } from '@splidejs/splide'; 
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export const init = () => {
  const carousels = document.querySelectorAll('.carousel_type-15');
  if (!carousels.length) return;

  const defaultOptions = {
    type: 'loop',
    drag: 'free',
    focus: 'center',
    arrows: false,
    pagination: false,
    autoWidth: true,
    gap: 80,
    autoScroll: {
      speed: 0.5,
    },
    breakpoints: {
      1055: {
        gap: 64,
      },
      671: {
        gap: 32,
      },
    },
  };

  carousels.forEach((carousel) => {
    const splideInstance = new Splide(carousel, defaultOptions);
    splideInstance.mount({ AutoScroll }); 
    carousel.splideInstance = splideInstance;
  });
};